import { PromoModalRoot } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCpdCianSource,
  setCpdSource,
  setCustomCpdDealType,
  setLabelModalOpen,
  setPrelandingModalOpen,
} from 'shared/actions/cpd';
import { CpdLabelModalContent } from 'shared/components/CpdLabelModal';
import { MAP_MODAL_CONTENT } from 'shared/components/CpdLabelModal/constants';
import { trackCreteCpdDraftClick, trackModalOpen } from 'shared/containers/CpdLabelModals/tracking';
import { selectCpdLabelModalState, selectCpdSource } from 'shared/selectors/cpd/cpd';
import { ECpdLabelModalView, ECpdPrelandingModalView } from 'shared/types/cpd/cpd';

export const CpdLabelModalsContainer: React.FC = () => {
  const modalState = useSelector(selectCpdLabelModalState);
  const source = useSelector(selectCpdSource);

  const dispatch = useDispatch();

  const handleClose = React.useCallback(() => {
    dispatch(setLabelModalOpen({ isOpen: false, modalView: ECpdLabelModalView.None }));
  }, [dispatch]);

  const handlePrelandingOpen = React.useCallback(() => {
    handleClose();
    dispatch(setPrelandingModalOpen({ isOpen: true, modalView: ECpdPrelandingModalView.Searcher }));
    dispatch(setCpdCianSource('offerScreenCpdCardDealObject'));
    dispatch(setCpdSource('offerScreenCpdCardDealObject'));
    dispatch(setCustomCpdDealType('sale'));

    trackCreteCpdDraftClick();
  }, []);

  React.useEffect(() => {
    if (modalState && modalState.isOpen && source) {
      trackModalOpen(source);
    }
  }, [modalState, source]);

  if (!modalState || modalState.modalView === ECpdLabelModalView.None) {
    return null;
  }

  return (
    <PromoModalRoot open={modalState.isOpen} onOpenChange={handleClose}>
      <CpdLabelModalContent
        {...MAP_MODAL_CONTENT[modalState.modalView]}
        onPrimaryAction={handleClose}
        onSecondaryAction={modalState.modalView === ECpdLabelModalView.Sdelka ? handlePrelandingOpen : undefined}
      />
    </PromoModalRoot>
  );
};
